"use client";

import { c as _c } from "react/compiler-runtime";
import { CurrencyFormatter } from "@sticker-giant/sg-frontend-common";
import Link from "next/link";
import { MatchedAttributesBadges } from "@/app/_components/Search/MatchedAttributesBadges";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { toEcommerceProduct, trackProductClicked } from "@/lib/analytics/segment";
import type { ProductHit } from "@/lib/search/types";
import { PlpProductCardRating } from "./PlpProductCardRating";
import { PlpProductCardThumbnail } from "./PlpProductCardThumbnail";
interface Props {
  hit: ProductHit;
  position: number;
  showMatchedAttributes?: boolean;
}
function formatPrice(startingPrice: number | undefined): string | null {
  if (typeof startingPrice !== "number") return null;
  return `From ${CurrencyFormatter.formatUSD(startingPrice)}`;
}
export function PlpProductCard(t0) {
  const $ = _c(35);
  const {
    hit,
    position,
    showMatchedAttributes
  } = t0;
  const title = hit.displayName || hit.name;
  let t1;
  if ($[0] !== hit.startingPrice) {
    t1 = formatPrice(hit.startingPrice);
    $[0] = hit.startingPrice;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const priceLabel = t1;
  const renderBadges = showMatchedAttributes && hit.matchedAttributes.length > 0;
  const t2 = `/${hit.slug}`;
  let t3;
  if ($[2] !== hit || $[3] !== position) {
    t3 = () => trackProductClicked(toEcommerceProduct(hit, position));
    $[2] = hit;
    $[3] = position;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== hit.imageAlt || $[6] !== hit.imageUrl || $[7] !== hit.plpFlag || $[8] !== title) {
    t4 = <PlpProductCardThumbnail imageUrl={hit.imageUrl} imageAlt={hit.imageAlt} title={title} plpFlag={hit.plpFlag} />;
    $[5] = hit.imageAlt;
    $[6] = hit.imageUrl;
    $[7] = hit.plpFlag;
    $[8] = title;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== title) {
    t5 = <h3 className="font-sans text-base font-semibold leading-none text-card-foreground">{title}</h3>;
    $[10] = title;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== hit.description) {
    t6 = hit.description && <p className="line-clamp-2 text-sm leading-5 text-muted-foreground">{hit.description}</p>;
    $[12] = hit.description;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== priceLabel) {
    t7 = priceLabel && <p className="text-sm font-bold leading-5 text-foreground">{priceLabel}</p>;
    $[14] = priceLabel;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== hit.matchedAttributes || $[17] !== renderBadges) {
    t8 = renderBadges && <MatchedAttributesBadges attrs={hit.matchedAttributes} />;
    $[16] = hit.matchedAttributes;
    $[17] = renderBadges;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t5 || $[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
    t9 = <CardContent className="flex flex-1 flex-col gap-1.5 pt-6">{t5}{t6}{t7}{t8}</CardContent>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== hit.ratingAverage || $[25] !== hit.ratingCount) {
    t10 = <CardFooter className="mt-auto pb-6 pt-6"><PlpProductCardRating ratingAverage={hit.ratingAverage} ratingCount={hit.ratingCount} /></CardFooter>;
    $[24] = hit.ratingAverage;
    $[25] = hit.ratingCount;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t4 || $[29] !== t9) {
    t11 = <Card className="h-full gap-0 overflow-hidden rounded-md py-0">{t4}{t9}{t10}</Card>;
    $[27] = t10;
    $[28] = t4;
    $[29] = t9;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t11 || $[32] !== t2 || $[33] !== t3) {
    t12 = <Link href={t2} onClick={t3} className="group block no-underline! hover:opacity-100! focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-md" data-testid="plp-product-card">{t11}</Link>;
    $[31] = t11;
    $[32] = t2;
    $[33] = t3;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  return t12;
}